import { AlertCircle } from 'lucide-react-native';
import { Component, ReactNode } from 'react';

import { Card } from '@/components/ui/card';
import { HStack } from '@/components/ui/hstack';
import { Icon } from '@/components/ui/icon';
import { Text } from '@/components/ui/text';
import { Sentry } from '@/util/sentry';

type InquiryCardErrorBoundaryProps = {
  children: ReactNode;
  conversationId?: string;
};

type InquiryCardErrorBoundaryState = {
  hasError: boolean;
};

export class InquiryCardErrorBoundary extends Component<
  InquiryCardErrorBoundaryProps,
  InquiryCardErrorBoundaryState
> {
  constructor(props: InquiryCardErrorBoundaryProps) {
    super(props);

    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): InquiryCardErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    Sentry.captureException(error, {
      tags: {
        component: 'InquiryCardErrorBoundary',
        boundaryType: 'inquiry-card',
      },
      extra: {
        errorMessage: error?.message,
        errorName: error?.name,
        componentStack: errorInfo?.componentStack,
        conversationId: this.props.conversationId,
      },
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <Card size="lg" className="m-0 p-3">
          <HStack space="md" className="items-center">
            <Icon as={AlertCircle} size="sm" className="text-typography-400" />
            <Text size="sm" className="text-typography-500">
              Unable to load this message
            </Text>
          </HStack>
        </Card>
      );
    }

    return this.props.children;
  }
}
